namespace GeniuzPOS.Product {
    export class CsMatTypeColumns {
        static columnsKey = 'Product.CsMatType';
    }
}
